import React, { createContext, useContext, useMemo } from "react";
import content from "./content";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const value = useMemo(
    () => ({ content, loading: false, saving: false }),
    []
  );
  return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
}

export function useContent() {
  const ctx = useContext(ContentContext);
  if (!ctx) throw new Error("useContent must be used inside ContentProvider");
  return ctx;
}
